import { useEffect, useState } from "react";
import servicosAtribuicaoExterna from "../servicos/servicos-externos/servicos-atribuicao-externa"
import servicosSolicitacaoExterna from "../servicos/servicos-solicitacao-externa";
import servicosItemPedido from "../servicos/servicos-item-pedido";
import { useContext } from "react";
import AuthContext from "../servicos/autorizacao/AuthContex";
import { DataGrid } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import { localizedTextsMap } from "../utils/localizedTextsMap";
import NavMobile from "./components/NavMobile";
import List from "../img/svgs/List";
import { Modal } from "react-bootstrap";
import Cancel from "../img/svgs/Cancel";

const columnsAtribuicoes = [
  { field: "id_milhas", headerName: "ID", width: 45 },
  {
    field: "Motivo[0].descricao",
    headerName: "Motivo",
    width: 250,
    editable: false,
    valueGetter: (params) => {
      return params.row.Motivo[0].descricao
    }
  },
  {
    field: "Motivo[0].qtd_milhas",
    headerName: "Milhas Item",
    width: 100,
    editable: false,
    valueGetter: (params) => {
      return params.row.Motivo[0].qtd_milhas
    }
  },
  {
    field: "qtd_producao",
    headerName: "Qtd Atribu.",
    width: 100,
    editable: false
  },
  {
    field: "qtd_milhas_atribuicao",
    headerName: "Total",
    width: 100,
    editable: false
  },
  {
    field: "data",
    headerName: "Data Atribuição",
    valueGetter: (params) => {
      let aux = String(params.value).split("-");
      let ano = aux[0];
      let mes = aux[1];
      let dia = aux[2];
      let dataFormatada = `${dia}-${mes}-${ano}`;
      return dataFormatada;
    }
  }
];

const HistoricoExterno = () => {
  const { user } = useContext(AuthContext);
  const [minhasAtribuicoes, setMinhasAtribuicoes] = useState([]);
  const [minhasSolicitacoes, setMinhasSolicitacoes] = useState([]);
  const [showEntradas, setShowEntradas] = useState(true);
  const [showSaidas, setShowSaidas] = useState(false);
  const [pedido, setPedido] = useState([]);
  const [showDetalhes, setShowDetalhes] = useState(false);

  const handleCloseDetalhes = () => setShowDetalhes(false);


  useEffect(() => {
    servicosAtribuicaoExterna.listarPorIdColaborador(user.id)
      .then(response => {
        if (response.status === 200) {
          const items = []
          response.data.allRegister.forEach(element => {
            items.push(element)
          });
          setMinhasAtribuicoes(items);
        }
      }).catch(error => {
        console.log(error);
      })
  }, [user.id])

  useEffect(() => {
    servicosSolicitacaoExterna.listarSolicitacaoExternaPorColaborador(user.id)
      .then(response => {
        if (response.status === 200) {
          const items = []
          response.data.forEach(element => {
            if (element.status === 'finalizado') {
              items.push(element)
            }
          });
          setMinhasSolicitacoes(items);
        }
      }).catch(error => {
        console.log(error);
      })
  }, [user.id])

  const handleShowEntradas = () => {
    setShowEntradas(true);
    setShowSaidas(false);
  }
  const handleShowSaidas = () => {
    setShowSaidas(true);
    setShowEntradas(false);
  }

  const styleH3 = {
    color: "#753BBD",
    fontSize: "24px"
  }

  const handleShowDetalhes = (pedido) => {
    let id = pedido.id_solicitacao_externa;
    let listaItems = [];
    servicosItemPedido.listarUm(id).then(response => {
      if (response.status === 200) {
        listaItems = response.data;
        let item = {
          id: id,
          items: listaItems,
          pedido: pedido
        }

        setPedido(item);

        setShowDetalhes(true);
      }
    })

  }

  const columnsSolicitacao = [
    {
      field: "id_solicitacao_extern",
      headerName: "",
      align: "center",
      width: 70,
      renderCell: (params) => {
        return <button type="button" onClick={() => handleShowDetalhes(params.row)}><List /></button>
      }
    },
    { field: "id_solicitacao_externa", headerName: "PEDIDO", width: 90 },
    {
      field: "status",
      headerName: "Status",
      width: 100,
      editable: false
    },
    {
      field: "cdg_parceiro",
      headerName: "Cód. Agente",
      width: 100,
      editable: true,
    },
    {
      field: "milhas_solicitacao",
      headerName: "Total",
      width: 100,
      editable: false,
    },
    {
      field: "data_solicitacao",
      headerName: "Data Solicitação",
      width: 120,
      editable: false,
      valueGetter: (params) => {
        if (params.value !== null) {
          let aux = String(params.row.data_solicitacao).split("-");
          let ano = aux[0];
          let mes = aux[1];
          let dia = aux[2];
          let dataFormatada = `${dia}-${mes}-${ano}`;
          return dataFormatada;
        }
      }
    },
    {
      field: "data_entrega",
      headerName: "Data Entrega",
      width: 120,
      editable: false,
      valueGetter: (params) => {
        if (params.value !== null) {
          let aux = String(params.row.data_entrega).split("-");
          let ano = aux[0];
          let mes = aux[1];
          let dia = aux[2];
          let dataFormatada = `${dia}-${mes}-${ano}`;
          return dataFormatada;
        }
      }
    },
    {
      field: "motivo_solicitacao",
      headerName: "Motivo Sol.",
      width: 180,
      editable: true
    },
    {
      field: "observacao",
      headerName: "Observação",
      width: 150,
      editable: true
    },

    {
      field: "responsavel",
      headerName: "Entregue por",
      width: 180,
      editable: true
    },

  ];

  const ListaItemsPedido = (props) => {
    return <>
      {props.lista !== undefined && <div className="w-50 mt-4">
        <table className="lista-items-dados-solicitacao">
          <thead>
            <tr className="border">
              <th>Produto</th>
              <th className="text-center">Qtd</th>
              <th className="text-center">Subtotal</th>
            </tr>
          </thead>
          <tbody>
            {props.lista.items.map(item => {
              return <tr key={item.id_produto} className="border">
                <td width={100}>{item.Produto[0].nome}</td>
                <td width={60} className="text-center">{item.qtd_produto}</td>
                <td className="text-center">{item.milhas}</td>
              </tr>
            })}
          </tbody>

        </table>
      </div>}
    </>
  }

  const ModalDetalhamentoPedido = () => {
    return <>

      <Modal className="modal-lg" show={showDetalhes} onHide={handleCloseDetalhes}>
        <Modal.Body className="" >
          <div >
            <div className="d-flex modal-detalhes-items justify-content-center">

              {
                pedido.pedido && <div>
                  <div className="info-solicitacao-externa p-1 d-flex justify-content-between">
                    <span style={{ fontSize: 18 }} className="ms-2">Dados Solicitação:</span>
                    <button style={{ width: 10 }} className=" p-1 rounded w-25" onClick={handleCloseDetalhes}>
                      <Cancel /> Voltar
                    </button>
                  </div>
                  <div className="dados-solicitacao-externa d-flex ">
                    <div className="w-50 mt-3 justify-content-center row">
                      <div>Pedido: <span className="font-weight-bold">{pedido.id}</span></div>
                      <div>Código Agente: <span className="font-weight-bold">{pedido.pedido.cdg_parceiro}</span></div>
                      <div>Data Solicitação: <span className="font-weight-bold">{pedido.pedido.data_solicitacao}</span></div>
                      <div>Data Entrega: <span className="font-weight-bold">{pedido.pedido.data_entrega}</span></div>
                      <div>Total Solicitação:<span className="font-weight-bold">{pedido.pedido.milhas_solicitacao}</span></div>
                      <div>Motivo Solicitação: <span className="font-weight-bold">{pedido.pedido.motivo_solicitacao}</span></div>
                      <div>Observação: <span className="font-weight-bold">{pedido.pedido.observacao}</span></div>
                      <div>Responsável: <span className="font-weight-bold">{pedido.pedido.responsavel}</span></div>
                      <div>Status: <span className="font-weight-bold">{pedido.pedido.status}</span> </div>
                    </div>
                    <ListaItemsPedido lista={pedido} />
                  </div>
                </div>
              }

            </div>
          </div>
        </Modal.Body>

      </Modal>

    </>
  }
  return <>
    <ModalDetalhamentoPedido />

    <div className="container">
      <div className="mt-3">
        <a className="subtitulo" style={{ fontSize: 24 }} href="/">Home</a>
        <a className="subtitulo ms-3" style={{ fontSize: 24 }} href="/SolicitacoesExterna">Menu Anterior</a>
      </div>
      <h3 style={styleH3} className="text-center subtitulo">Histórico Milhas de Produção</h3>
      <div className="container text-center mt-3 mb-4">
        <button className="btn-movimetacao" type="button" onClick={handleShowEntradas}>Entradas</button>
        <button type="button" className="btn-movimetacao ms-2" onClick={handleShowSaidas}>Saídas</button>
      </div>
      {showEntradas && <div className="d-flex justify-content-center row align-items-center" >
        <h3 className="">Entradas</h3>
        <Box sx={{ height: 620, width: 1300 }}>
          <DataGrid
            style={{ borderRadius: "20px" }}
            localeText={localizedTextsMap}
            rows={minhasAtribuicoes}
            columns={columnsAtribuicoes}
            pageSize={10}
            rowsPerPageOptions={[10]}
            disableSelectionOnClick
            getRowId={(row) => row.id_milhas}
            getRowClassName={(params) =>
              params.indexRelativeToCurrentPage % 2 === 0 ? 'Mui-even' : 'Mui-odd'
            }
          />
        </Box>


      </div>
      }
      {showSaidas && <div className="d-flex justify-content-center row align-items-center">
        <h3 className="">Saídas</h3>
        <Box sx={{ height: 650, width: 1300 }}>
          <DataGrid
            localeText={localizedTextsMap}
            rows={minhasSolicitacoes}
            columns={columnsSolicitacao}
            pageSize={10}
            rowsPerPageOptions={[10]}
            getRowId={(row) => row.id_solicitacao_externa}
            getRowClassName={(params) =>
              params.indexRelativeToCurrentPage % 2 === 0 ? 'Mui-even' : 'Mui-odd'
            }
          />
        </Box>


      </div >}
    </div>
    <NavMobile />
  </>
}

export default HistoricoExterno;